import { render } from "./AdBannerCreate.vue?vue&type=template&id=82c06f2e&scoped=true"
import script from "./AdBannerCreate.vue?vue&type=script&lang=js"
export * from "./AdBannerCreate.vue?vue&type=script&lang=js"

import "./AdBannerCreate.vue?vue&type=style&index=0&id=82c06f2e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82c06f2e"]])

export default __exports__